// Wait for DOM to be ready

function cursorCustom() {
    // Get the portrait container
    const portraitContainer = document.querySelector('.portrait-container');

    if (!portraitContainer) {
        // Retry after a short delay
        setTimeout(cursorCustom, 100);
        return;
    }

    // Path tracking
    const mousePath = [];
    const maxPathLength = 30;
    let currentSpeed = 0;
    let lastMousePosition = { x: 0, y: 0 };

    // Dynamic delays
    const baseFollower1Delay = 3;
    const baseFollower2Delay = 6;
    const minFollower1Delay = 1;
    const minFollower2Delay = 2;

    // Movement detection
    let lastMouseTime = Date.now();
    let isMoving = false;
    let stopTimer = null;
    let hasBeenStopped = false;
    const movementThreshold = 30;

    // Current positions with velocity for smooth convergence
    let currentPositions = {
        main: { x: 0, y: 0 },
        follower1: { x: 0, y: 0, vx: 0, vy: 0 },
        follower2: { x: 0, y: 0, vx: 0, vy: 0 }
    };

    // Create cursor elements
    const mainCursor = document.createElement('div');
    mainCursor.className = 'cursor-circle main-cursor';
    mainCursor.style.cssText = `
        position: fixed;
        width: 20px;
        height: 20px;
        border: 2px solid #000;
        background: transparent;
        border-radius: 50%;
        pointer-events: none;
        z-index: 10001;
        transition: none;
        transform: translate(-50%, -50%);
        opacity: 0;
    `;

    const followCursor1 = document.createElement('div');
    followCursor1.className = 'cursor-circle follow-cursor-1';
    followCursor1.style.cssText = `
        position: fixed;
        width: 20px;
        height: 20px;
        border: 2px solid #000;
        background: transparent;
        border-radius: 50%;
        pointer-events: none;
        z-index: 10000;
        opacity: 0;
        transition: none;
        transform: translate(-50%, -50%);
    `;

    const followCursor2 = document.createElement('div');
    followCursor2.className = 'cursor-circle follow-cursor-2';
    followCursor2.style.cssText = `
        position: fixed;
        width: 20px;
        height: 20px;
        border: 2px solid #000;
        background: transparent;
        border-radius: 50%;
        pointer-events: none;
        z-index: 9999;
        opacity: 0;
        transition: none;
        transform: translate(-50%, -50%);
    `;

    // Append cursors to body
    document.body.appendChild(mainCursor);
    document.body.appendChild(followCursor1);
    document.body.appendChild(followCursor2);

    // Hide default cursor on portrait container
    portraitContainer.style.cursor = 'none';

    // Track mouse movement on portrait container
    portraitContainer.addEventListener('mousemove', (e) => {
        // Calculate speed
        const deltaX = e.clientX - lastMousePosition.x;
        const deltaY = e.clientY - lastMousePosition.y;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        
        // Smooth speed calculation with exponential moving average
        currentSpeed = currentSpeed * 0.7 + distance * 0.3;
        
        lastMousePosition.x = e.clientX;
        lastMousePosition.y = e.clientY;
        
        // Add to path
        mousePath.push({
            x: e.clientX,
            y: e.clientY,
            timestamp: Date.now(),
            speed: currentSpeed
        });
        
        // Keep path short for tight following
        if (mousePath.length > maxPathLength) {
            mousePath.shift();
        }
        
        // Update movement detection
        lastMouseTime = Date.now();
        if (!isMoving) {
            isMoving = true;
            hasBeenStopped = false;
        }
        
        // Clear any stop timer
        if (stopTimer) {
            clearTimeout(stopTimer);
            stopTimer = null;
        }
        
        // Update main cursor position
        currentPositions.main.x = e.clientX;
        currentPositions.main.y = e.clientY;
    });

    // Check if mouse stopped moving with debouncing
    function checkMovement() {
        const now = Date.now();
        if (now - lastMouseTime > movementThreshold && isMoving) {
            isMoving = false;
            hasBeenStopped = true;
        }
    }

    // Animation loop
    function animate() {
        checkMovement();
        
        if (mousePath.length === 0) {
            requestAnimationFrame(animate);
            return;
        }
        
        // Update main cursor
        mainCursor.style.left = currentPositions.main.x + 'px';
        mainCursor.style.top = currentPositions.main.y + 'px';
        
        if (isMoving && mousePath.length > Math.max(minFollower1Delay, minFollower2Delay)) {
            // Calculate dynamic delays based on speed
            const speedFactor = Math.min(currentSpeed / 15, 1);
            const follower1Delay = Math.round(baseFollower1Delay - (baseFollower1Delay - minFollower1Delay) * speedFactor);
            const follower2Delay = Math.round(baseFollower2Delay - (baseFollower2Delay - minFollower2Delay) * speedFactor);
            
            // Moving: followers follow the path with dynamic delay
            hasBeenStopped = false;
            const follower1Index = Math.max(0, mousePath.length - 1 - follower1Delay);
            const follower2Index = Math.max(0, mousePath.length - 1 - follower2Delay);
            
            // Check if we just started moving from a stopped state
            const justStartedMoving = mousePath.length > 0 && (Date.now() - lastMouseTime) < 100;
            
            if (follower1Index < mousePath.length) {
                const pos1 = mousePath[follower1Index];
                if (justStartedMoving) {
                    const transitionFactor = 0.3;
                    currentPositions.follower1.x += (pos1.x - currentPositions.follower1.x) * transitionFactor;
                    currentPositions.follower1.y += (pos1.y - currentPositions.follower1.y) * transitionFactor;
                } else {
                    currentPositions.follower1.x = pos1.x;
                    currentPositions.follower1.y = pos1.y;
                }
                currentPositions.follower1.vx = 0;
                currentPositions.follower1.vy = 0;
            }
            
            if (follower2Index < mousePath.length) {
                const pos2 = mousePath[follower2Index];
                if (justStartedMoving) {
                    const transitionFactor = 0.2;
                    currentPositions.follower2.x += (pos2.x - currentPositions.follower2.x) * transitionFactor;
                    currentPositions.follower2.y += (pos2.y - currentPositions.follower2.y) * transitionFactor;
                } else {
                    currentPositions.follower2.x = pos2.x;
                    currentPositions.follower2.y = pos2.y;
                }
                currentPositions.follower2.vx = 0;
                currentPositions.follower2.vy = 0;
            }
        } else {
            // Stopped: Start convergence immediately
            const smoothFactor = 0.25;
            
            currentPositions.follower1.x += (currentPositions.main.x - currentPositions.follower1.x) * smoothFactor;
            currentPositions.follower1.y += (currentPositions.main.y - currentPositions.follower1.y) * smoothFactor;
            
            currentPositions.follower2.x += (currentPositions.main.x - currentPositions.follower2.x) * smoothFactor;
            currentPositions.follower2.y += (currentPositions.main.y - currentPositions.follower2.y) * smoothFactor;
            
            // When very close, snap to exact position
            const distance1 = Math.sqrt(
                Math.pow(currentPositions.main.x - currentPositions.follower1.x, 2) + 
                Math.pow(currentPositions.main.y - currentPositions.follower1.y, 2)
            );
            const distance2 = Math.sqrt(
                Math.pow(currentPositions.main.x - currentPositions.follower2.x, 2) + 
                Math.pow(currentPositions.main.y - currentPositions.follower2.y, 2)
            );
            
            if (distance1 < 0.5) {
                currentPositions.follower1.x = currentPositions.main.x;
                currentPositions.follower1.y = currentPositions.main.y;
            }
            if (distance2 < 0.5) {
                currentPositions.follower2.x = currentPositions.main.x;
                currentPositions.follower2.y = currentPositions.main.y;
            }
        }
        
        // Update follower positions
        followCursor1.style.left = currentPositions.follower1.x + 'px';
        followCursor1.style.top = currentPositions.follower1.y + 'px';
        
        followCursor2.style.left = currentPositions.follower2.x + 'px';
        followCursor2.style.top = currentPositions.follower2.y + 'px';
        
        requestAnimationFrame(animate);
    }

    // Initialize positions
    let initialized = false;
    portraitContainer.addEventListener('mousemove', (e) => {
        if (!initialized) {
            lastMousePosition.x = e.clientX;
            lastMousePosition.y = e.clientY;
            currentPositions.main.x = e.clientX;
            currentPositions.main.y = e.clientY;
            currentPositions.follower1.x = e.clientX;
            currentPositions.follower1.y = e.clientY;
            currentPositions.follower1.vx = 0;
            currentPositions.follower1.vy = 0;
            currentPositions.follower2.x = e.clientX;
            currentPositions.follower2.y = e.clientY;
            currentPositions.follower2.vx = 0;
            currentPositions.follower2.vy = 0;
            
            // Fill initial path
            for (let i = 0; i < maxPathLength; i++) {
                mousePath.push({
                    x: e.clientX,
                    y: e.clientY,
                    timestamp: Date.now(),
                    speed: 0
                });
            }
            
            initialized = true;
        }
    }, { once: true });

    // Start animation
    animate();

    // Handle cursor visibility
    portraitContainer.addEventListener('mouseleave', () => {
        mainCursor.style.opacity = '0';
        followCursor1.style.opacity = '0';
        followCursor2.style.opacity = '0';
    });

    portraitContainer.addEventListener('mouseenter', () => {
        mainCursor.style.opacity = '1';
        followCursor1.style.opacity = '0.7';
        followCursor2.style.opacity = '0.5';
    });

    // Hover effects
    portraitContainer.addEventListener('mouseenter', () => {
        mainCursor.style.borderColor = '#000';
        followCursor1.style.borderColor = '#000';
        followCursor2.style.borderColor = '#000';
    });

    portraitContainer.addEventListener('mouseleave', () => {
        mainCursor.style.borderColor = '#000';
        followCursor1.style.borderColor = '#000';
        followCursor2.style.borderColor = '#000';
    });
}


document.addEventListener('DOMContentLoaded', function() {
    window.cursorCustom = cursorCustom;
    cursorCustom();
});